import { FC, useMemo } from 'react';
import { CancelToken } from 'axios';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { FetchState } from '../../../../store/fetchState';
import { selectIdentityCompanyId } from '../../../../store/entities/identity';
import {
  getOptionsCompanySupplierEmployees,
  selectOptionsCompanySupplierEmployees,
  selectOptionsCompanySupplierEmployeesState,
} from '../../../../store/entities/optionsCompanySupplierEmployees';
import { QcsAutocomplete } from '../../../common/form/QcsAutocomplete';
import { getFirstLastNameObj } from '../../../../utils/format';
import { VisitationEmployeeRef } from './visitationTypes';

interface Props {
  multiple?: boolean;
  name: string;
  label?: React.ReactNode;
  supplierIds: string[];
}

export const VisitationEmployeeAutocomplete: FC<Props> = ({
  multiple,
  name,
  label,
  supplierIds,
}) => {
  const dispatch = useAppDispatch();
  const companyId = useAppSelector(selectIdentityCompanyId);
  const supplierEmployees = useAppSelector(selectOptionsCompanySupplierEmployees);
  const optionsState = useAppSelector(selectOptionsCompanySupplierEmployeesState);

  const mappedOptions = useMemo<VisitationEmployeeRef[]>(
    () =>
      supplierEmployees.map((dto) => ({
        id: dto.id!,
        name: getFirstLastNameObj(dto),
        supplierId: dto.supplier?.id,
      })),
    [supplierEmployees],
  );

  const loadOptions = (search: string | undefined, cancelToken: CancelToken) => {
    dispatch(getOptionsCompanySupplierEmployees(companyId, supplierIds, search, cancelToken));
  };

  return (
    <QcsAutocomplete<VisitationEmployeeRef>
      multiple={multiple}
      name={name}
      label={label}
      options={mappedOptions}
      loading={optionsState === FetchState.Loading}
      loadingError={optionsState === FetchState.Error}
      loadOptions={loadOptions}
      getOptionId={(option) => option.id}
      getOptionName={(option) => option.name}
      getValueIfNotFound={(option) => option}
    />
  );
};
